import React from "react";

const MAGNOLIA_IMG =
  "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/0j67xb17_Magnolia2.JPG";

const INTERIORS = [
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/7z77gx2n_47e630f8394c1401dcaa29ff8cb60577l-m5rd-w1280_h960.webp",
    alt: "Grand two-story foyer with curved staircase and magnolia floor medallion",
    caption: "Grand Foyer",
    sub: "Magnolia Medallion Inlay",
    span: "col-span-12 lg:col-span-7",
    testid: "magnolia-interior-foyer",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/8h64l2ar_47e630f8394c1401dcaa29ff8cb60577l-m3rd-w1280_h960.webp",
    alt: "Cherry wood library with coffered ceiling and built-in bookcases",
    caption: "The Library",
    sub: "Cherry Coffered Ceiling",
    span: "col-span-12 lg:col-span-5",
    testid: "magnolia-interior-library",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/oywl9faa_47e630f8394c1401dcaa29ff8cb60577l-m10rd-w1280_h960.webp",
    alt: "Two-story great room with dramatic full-height brick fireplace",
    caption: "Great Room",
    sub: "Two-Story Brick Hearth",
    span: "col-span-12 lg:col-span-8",
    testid: "magnolia-interior-greatroom",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/hea4f1p3_47e630f8394c1401dcaa29ff8cb60577l-m8rd-w1280_h960.webp",
    alt: "Library reading corner with red leather wingback chairs and brick fireplace",
    caption: "Library Study",
    sub: "Wingback & Brick",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    testid: "magnolia-interior-library-study",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/9ifrldd9_47e630f8394c1401dcaa29ff8cb60577l-m4rd-w1280_h960.webp",
    alt: "Formal entry hall with archways opening to dining and living rooms",
    caption: "Entry Hall",
    sub: "Arched Sightlines",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    testid: "magnolia-interior-hall",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/yrg9pk5v_47e630f8394c1401dcaa29ff8cb60577l-m15rd-w1280_h960.webp",
    alt: "Chef's kitchen with cherry cabinets, granite counters, and professional range",
    caption: "Chef's Kitchen",
    sub: "Cherry & Granite",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    testid: "magnolia-interior-kitchen",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/66pgjs5j_47e630f8394c1401dcaa29ff8cb60577l-m17rd-w1280_h960.webp",
    alt: "Butler's pantry and kitchen entry with stainless appliances and back staircase",
    caption: "Butler's Pantry",
    sub: "Secondary Prep · Back Stair",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    testid: "magnolia-interior-butlers",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/ge0qdg6a_47e630f8394c1401dcaa29ff8cb60577l-m6rd-w1280_h960.webp",
    alt: "Formal dining room with chandelier, marble fireplace, and fluted molding",
    caption: "Dining Room",
    sub: "Marble Hearth",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    testid: "magnolia-interior-dining",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/jke9z02o_47e630f8394c1401dcaa29ff8cb60577l-m7rd-w1280_h960.webp",
    alt: "Dining room wide view with paneled walls and gilded mirrors",
    caption: "Formal Dining",
    sub: "Panel & Pilaster Detail",
    span: "col-span-12 md:col-span-12 lg:col-span-4",
    testid: "magnolia-interior-formal",
  },
];

const HIGHLIGHTS = [
  { label: "Classical Revival", value: "Architecture" },
  { label: "Six Ionic Columns", value: "Front Portico" },
  { label: "Brick & Copper", value: "Material Palette" },
  { label: "Turn-Key Delivery", value: "Engagement" },
];

export default function SignatureProject() {
  return (
    <section
      id="signature-project"
      data-testid="signature-project-section"
      className="relative py-28 md:py-40 overflow-hidden"
    >
      {/* Subtle background flourish */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[var(--accent)]/5 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-7 reveal order-2 lg:order-1">
            <figure className="relative group">
              <div className="zoom-img aspect-[4/3] w-full border border-white/10 overflow-hidden">
                <img
                  src={MAGNOLIA_IMG}
                  alt="Magnolia Manor — classical red brick estate with six Ionic columns"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "center 12%" }}
                  loading="lazy"
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 8%, rgba(0,0,0,0.4) 22%, rgba(0,0,0,0) 45%)",
                  }}
                />
              </div>
              <figcaption className="absolute top-5 left-5">
                <span className="inline-flex items-center gap-2 px-4 py-2 border border-[var(--accent)]/60 backdrop-blur-sm bg-black/50 text-[10px] uppercase tracking-[0.3em] text-[var(--accent)] font-body">
                  ★ Signature Estate
                </span>
              </figcaption>
            </figure>
          </div>

          {/* Copy */}
          <div className="lg:col-span-5 reveal reveal-delay-1 order-1 lg:order-2">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline w-10" />
              <span className="eyebrow">Signature Project</span>
            </div>

            <h2 className="font-display text-5xl md:text-6xl leading-[1.02] tracking-tight text-[var(--text-primary)] mb-8">
              Magnolia <em className="text-[var(--accent)]">Manor</em>.
            </h2>

            <p className="text-[var(--text-secondary)] text-lg leading-relaxed mb-6">
              A classical brick estate defined by its grand central portico —
              six Ionic columns rising two stories beneath a pediment trimmed
              in copper. Dormered gables, leaded-glass transoms, and formal
              landscaping round out a home built to stand for generations.
            </p>

            <p className="text-[var(--text-secondary)] text-lg leading-relaxed mb-10">
              Magnolia Manor represents the upper end of what we build:
              deliberate architecture, uncompromising materials, and detail
              work measured in millimeters.
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6 border-t border-white/10 mb-10">
              {HIGHLIGHTS.map((h) => (
                <div key={h.label} data-testid={`magnolia-highlight-${h.label}`}>
                  <div className="font-display text-xl text-[var(--text-primary)]">
                    {h.value}
                  </div>
                  <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--accent)] mt-1">
                    {h.label}
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              className="btn-outline"
              data-testid="signature-project-cta"
            >
              Commission A Home
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </a>
          </div>
        </div>

        {/* INTERIORS GALLERY */}
        <div className="mt-24 md:mt-32 pt-16 border-t border-white/10">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
            <div className="reveal">
              <div className="flex items-center gap-4 mb-6">
                <span className="hairline w-10" />
                <span className="eyebrow">Inside Magnolia</span>
              </div>
              <h3 className="font-display text-4xl md:text-5xl leading-[1.05] tracking-tight">
                Craft, <em className="text-[var(--accent)]">room by room</em>.
              </h3>
            </div>
            <p className="reveal reveal-delay-1 text-[var(--text-secondary)] max-w-sm leading-relaxed">
              A two-story foyer with a hand-laid magnolia medallion, a cherry
              library beneath a coffered ceiling, a great room wrapped around a
              full-height brick hearth, and a chef's kitchen trimmed in cherry
              and granite — the interiors live up to the façade.
            </p>
          </div>

          <div className="grid grid-cols-12 gap-4 md:gap-6">
            {INTERIORS.map((p, i) => (
              <figure
                key={p.testid}
                className={`reveal ${p.span} group relative overflow-hidden border border-white/10`}
                style={{ transitionDelay: `${i * 70}ms` }}
                data-testid={p.testid}
              >
                <div className="zoom-img aspect-[4/3] w-full">
                  <img
                    src={p.url}
                    alt={p.alt}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0) 70%)",
                  }}
                />
                <figcaption className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--accent)] mb-1.5">
                    {p.sub}
                  </div>
                  <h4 className="font-display text-xl md:text-2xl text-white leading-tight">
                    {p.caption}
                  </h4>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
